import React, { memo, forwardRef } from 'react';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import {
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { Card } from 'react-bootstrap';
import { useAppContext } from '../../../providers/AppProvider';

echarts.use([
  BarChart,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  CanvasRenderer
]);

const getMaterialChartOptions = (theme, getThemeColor, data, unit) => {
  const categories = Object.keys(data);
  const values = Object.values(data);

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: params => {
        const item = params[0];
        return `<strong>${item.name}</strong><br>${item.value.toFixed(
          2
        )} ${unit}`;
      }
    },
    xAxis: {
      type: 'category',
      data: categories,
      axisLabel: {
        rotate: 30,
        fontSize: 11,
        color: getThemeColor('gray-800')
      },
      axisLine: { lineStyle: { color: getThemeColor('gray-300') } }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        fontSize: 12,
        formatter: `{value} ${unit}`,
        color: getThemeColor('gray-800')
      },
      splitLine: { lineStyle: { color: getThemeColor('gray-300') } }
    },
    series: [
      {
        type: 'bar',
        barWidth: 12,
        data: values,
        itemStyle: {
          color: getThemeColor('primary')
        },
        label: {
          show: true,
          position: 'top',
          fontSize: 10,
          color: getThemeColor('gray-800'),
          formatter: p => `${p.value.toFixed(1)} ${unit}`
        }
      }
    ],
    grid: {
      left: '5%',
      right: '5%',
      bottom: '20%',
      top: '10%',
      containLabel: true
    }
  };
};

const MaterialTotalsChart = forwardRef(({ data, title, unit = 'kg' }, ref) => {
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  return (
    <Card className="h-100">
      <Card.Body>
        <div style={styles.headerContainer}>
          <div style={styles.title}>{title}</div>
        </div>
        <ReactEChartsCore
          ref={ref}
          echarts={echarts}
          option={getMaterialChartOptions(theme, getThemeColor, data, unit)}
          style={{ height: '400px', width: '100%' }}
        />
      </Card.Body>
    </Card>
  );
});

const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333'
  }
};

export default memo(MaterialTotalsChart);
